module.exports = __webpack_public_path__ + "font/96c476804d7a788cc1c05351b287ee41.eot";